import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import TranslateMoreLinks from '../NavLinks/TranslateMoreLinks';

const SidebarDoc = () => {
  const location = useLocation();
  const isMorePage = location.pathname === '/moresettings';

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <div className="w-64 bg-white text-green-700 p-7 relative">
        
        {/* Docs Link at the Top */}
        <div className="relative mb-4">
          <NavLink
            to="/moresettings"
            className="text-lg font-semibold text-green-700 hover:text-blue-400 transition"
            style={{ outline: 'none', boxShadow: 'none' }} // Completely remove outline
          >
            The More Settings
          </NavLink>

          {/* Blue Ping - Only when on the documentation page */}
          {isMorePage && (
            <span className="absolute top-[-6px] left-[-6px] w-2.5 h-2.5 bg-blue-500 rounded-full"></span>
          )}
        </div>

        {/* Menu Title */}
        <div className="text-2xl font-bold mb-6">Menu</div>

        {/* Menu Links */}
        <TranslateMoreLinks />
      </div>
    </div>
  );
};

export default SidebarDoc;
